export const actions = {
  LOAD_AVERAGE_REQUEST: 'users/LOAD_AVERAGE_REQUEST',
  LOAD_AVERAGE_TOUR_REQUEST: 'users/LOAD_AVERAGE_TOUR_REQUEST',
  LOAD_AVERAGE_RESULT: 'users/LOAD_AVERAGE_RESULT',
  CLEAR_AVERAGE: 'CLEAR_AVERAGE',
}

export function loadAverage(payload) {
  return {
    type: actions.LOAD_AVERAGE_REQUEST,
    payload,
  }
}

export function loadAverageTour(payload) {
  return {
    type: actions.LOAD_AVERAGE_TOUR_REQUEST,
    payload,
  }
}

export const clearAverage = () => ({ type: actions.CLEAR_AVERAGE })
